export default __webpack_public_path__ + "static/media/1-step.c7b51ff2.png";